import { FormControl, FormGroup } from '@angular/forms';
import { createKeyValueArrayForm } from '@src/app/modules/key-value-array';

import { FormDataType, FormType, Methods, SourceTypes } from './types';

export const createForm = (initValues?: Partial<FormDataType>) => {
  return new FormGroup<FormType>({
    type: new FormControl(initValues?.type || SourceTypes.Local, { nonNullable: true }),
    defaultValue: new FormControl(null),
    driver: new FormControl(null),
    username: new FormControl(null),
    password: new FormControl(null),
    query: new FormControl(null),
    uri: new FormControl(null),
    method: new FormControl(Methods.POST),
    headers: createKeyValueArrayForm(),
    body: createKeyValueArrayForm(),
  });
};
